import {useQuery} from "@tanstack/react-query";
import {getCustomBoardsService} from "../../services/games/customBoards/customBoards.service";

export const useGetCustomBoards = () => {
  const {data, isPending} = useQuery({
    queryKey: ["customBoards"],
    queryFn: getCustomBoardsService,
    select: responseData => responseData?.data?.data ?? [],
  });

  return {data: data ?? [], isPending};
};
